import React,{memo} from "react";
import { Link as DomLink, useLocation, useNavigate } from "react-router-dom";
import { animateScroll as scroll, Element } from "react-scroll";
import { Box, Container, Grid, Typography, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import { useMyContext } from "../../MyContext";
import ProductLogo from "../../components/ProductLogo";
import DefaultButton from "../../components/DefaultButton";
import DirectionsIcon from "@mui/icons-material/Directions";
import SocialIcons from "./SocialIcons";
import PromoBanner from "../../components/PromoBanner";
import {
  getLanguageFromPathname,
  getLocalizedPath,
  normalizeLanguage,
} from "../../locales/routing";

const Section = styled("section")(({ theme }) => ({
  padding: theme.spacing(4, 0, 0, 0),
  textAlign: "center",
  backgroundColor: theme.palette.secondary.background,
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.h1.fontFamily,
  fontSize: "54px",
  marginBottom: theme.spacing(2),
  textTransform: "uppercase",
  fontWeight: 700,
}));

const Slogan = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: "32px",
  marginBottom: theme.spacing(1),
}));

const FooterContainer = styled(Container)(({ theme }) => ({
  paddingBottom: theme.spacing(2),
  fontFamily: theme.typography.fontFamily,
}));

const ContactInfo = styled(Grid)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: "17px",
}));

const ContactIcon = styled("span")(({ theme }) => ({
  // marginRight: theme.spacing(1),
  verticalAlign: "middle",
}));

const CopyrightInfo = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2),
  fontSize: "14px",
  opacity: 0.8,
}));


const Footer = memo(function Footer() {
  const { rest, isSmallScreen } = useMyContext();
  const { name, slogan, tel, email, address, coords } = rest;
  const loc = coords.restSpot;
  const navigate = useNavigate();
  const location = useLocation();

  const handleReviewClick = () => {
    window.open(
      "https://kalikratia.bbqr.site/en/restaurants/dusha",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleDocumentsClick = () => {
    const lang = normalizeLanguage(getLanguageFromPathname(location.pathname));
    navigate(getLocalizedPath(lang, "/docs"));
    scroll.scrollToTop();
  };

  const handleClick = () => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${loc.latitude},${loc.longitude}`,
      "_blank"
    );
  };


  return (
    <Section>
      <FooterContainer>
        <SectionTitle variant="h3">{name}</SectionTitle>
        <Slogan>{slogan}</Slogan>
        <Box
          sx={{
            justifyContent: "center",
            padding: 0.1,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <SocialIcons />
        </Box>
        <Element name="contacts">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2.5,
              alignItems: "center",
              width: "100%",
              mt: 2,
              mb: 1.5,
            }}
          >
            {/* <DefaultButton
              onClick={handleReviewClick}
              label="Review on Kalikratia Site"
              relative={true}
              minWidth="100%"
              color="white"
            /> */}
            <DefaultButton
              onClick={handleDocumentsClick}
              label="Documents and Licenses"
              relative={true}
              minWidth="100%"
              color="white"
            />
            <DefaultButton
              onClick={handleClick}
              label="Get Directions"
              relative={true}
              minWidth="100%"
              startIcon={<DirectionsIcon />}
              target="_blank"
              rel="noopener noreferrer"
              color="white"
            />
            {/* <PromoBanner placement="footer" /> */}
          </Box>
          <ContactInfo container spacing={0}>
            <Grid item xs={12} md={4}>
              <ContactIcon onClick={handleClick} sx={{ curson: "pointer" }}>
                <LocationOnIcon />
              </ContactIcon>
              {address}
            </Grid>

            <Grid item xs={12} md={4}>
              <ContactIcon>
                <EmailIcon />
              </ContactIcon>
              <a href={`mailto:${email}`}>{email}</a>
            </Grid>
            <Grid item xs={12} md={4}>
              <ContactIcon>
                <CallIcon />
              </ContactIcon>
              <a href={`tel:${tel}`}>{tel}</a>
            </Grid>
          </ContactInfo>
        </Element>
        <CopyrightInfo>
          &copy; {new Date().getFullYear()}{" "}
          <Link
            href="https://nataliaki.eu"
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
            underline="hover"
          >
            Made by Nataliaki
          </Link>
          . All Rights Reserved.{" "}
          <ProductLogo
            isSmallScreen={isSmallScreen}
            navigate={navigate}
          />
        </CopyrightInfo>
      </FooterContainer>
    </Section>
  );
});

export default Footer;
